import { Injectable } from '@angular/core';
import { GlobalVars } from '../../providers/global-vars/globalVars';
import { Http, Headers } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';

/*
  Generated class for the ApiServiceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ApiServiceProvider {

	constructor(
		public http: Http,
		public httpClient: HttpClient,
		public globalVars: GlobalVars
		) {
	}


	getLocalJson(url){
	  	return new Promise((resolve, reject) => {
		    this.http.get(url)
		    .map(res => res.json())
		    .subscribe(
		    	data => {
		  	    	resolve(data);
		        },
	  	    	err => { 
		  	    	reject(err);
	  	    	}
		    );
		});
	}

	getAPIFullCall(url, params) {
		return new Promise((resolve, reject) => {
		  this.http.get(this.globalVars.baseUrl + url, params)
		  .subscribe(
			  	response => {
					let headers: Headers = response['headers'];
					let returnObject = {
						headers: headers.toJSON(),
						body: response.json()
					};
					resolve(returnObject); // response.json()
			  	},
				err => { 
					reject(err);
				}
		  	);
	  	});
  	}

	getAPICall(url, params) {
	  	return new Promise((resolve, reject) => {
		    this.http.get(this.globalVars.baseUrl + url, params)
		    .map(res => res.json())
		    .subscribe(
		    	data => {
		  	    	resolve(data);
		        },
	  	    	err => { 
		  	    	reject(err);
	  	    	}
		    );
		});
	}

	postAPICall(url, params?) {
	  	return new Promise((resolve, reject) => {
		    var headers = new Headers();
		    headers.append('Content-Type', 'application/x-www-form-urlencoded');

		    this.http.post(this.globalVars.baseUrl + url, params, { headers: headers })
		    .map(res => res.json())
		    .subscribe(
		    	data => {
		  	    	resolve(data);
		        },
	  	    	err => { 
		  	    	reject(err);
	  	    	}
		    );
		});
	}

}



// WEBPACK FOOTER //
// ./src/providers/api-service/api-service.ts